import Layout from "../../components/shared/layout/layout";
import HorizontalScroll from "../../components/carousel/horizontalScroll";
import Link from "next/link";
// import InstagramFeed  from 'react-ig-feed'
import Award from "../../components/award/award";
import {useRouter} from "next/router";
import {useEffect, useState} from "react";
import Seo from "../../components/shared/seo/seo";
import { resolveImageUrl } from "../../lib/imageUrl";


function showAwardPopup(id) {
    let blog = document.getElementById(`awardPopup-${id}`);
    if(blog == null || blog == undefined) return;
    blog.style.display = "flex";
    
}

export default function News(){
 const [awards, setAwards] = useState(null);
    const router = useRouter();
    const { isReady, query: {id,}} = router;
    useEffect(() =>{
            if(awards == null){
                getAwards().then((data)=> setAwards(data));
            }
            if(id != undefined && id != null) {
                showAwardPopup(id);
            }
    }, [isReady]);

    function initAwards(awards) {
        const elements=[];
        for (let i = 0; i < awards.length; i++) {
            const award = awards[i];
                elements.push(
                    <a ward key={award.awardId} id={award.awardId} image={resolveImageUrl(award.imageLocation, 'auszeichnungen')} title={award.title} subtitle={award.subTitle} products={award.productAwards} description={award.description}/>
                );
        }
        return elements;
    }
    return(
        <Layout>
            <Seo
                title="News"
                description="Aktuelles vom Weingut Gisperg: Auszeichnungen, Pressestimmen und News."
                path="/news"
            />
            <section className="background_light no_fill">
                <div className="col-12">
                    <h1>News</h1>
                    <div className="horizontal">
                        <div className="col-3">
                            <Link href="#aktuelles"><p className="annotation marker brown link">Aktuelles</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#auszeichnungen"><p className="annotation marker brown link">Auszeichnungen</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#weinblog"><p className="annotation marker brown link">Wein Blog</p></Link>
                        </div>
                        <div className="col-3">
                            <Link href="#socialmedia"><p className="annotation marker brown link">Social Media</p></Link>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <span  className="anchor" id="aktuelles" ></span>
                    <h2 style={{marginTop:"100px"}}>Aktuelles</h2>
                    <div className="horizontal">
                        <div className="col-4 link" onClick={async () => await router.push("/weinkauf/shop/details/?id=17")}>
                            <img alt=""  width="100%" src="/images/Briefmarke_Ganswild.webp"/>
                        </div>
                        <div className="col-4 link" onClick={async () => await router.push("weinkauf/shop/details/?id=48")}>
                            <img alt=""  width="100%" src="/images/Briefmarke_Herbstpaket_2023.webp"/>
                        </div>
                        <div className="col-4 link" onClick={() => showAwardPopup("19")}>
                            <img alt=""  width="100%" src="/images/Briefmarke_Vinaria-Sommerwein-202319-1.webp"/>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_light_texture fullWidth">
                <span  className="anchor" id="auszeichnungen"></span>
                <div className="col-12">
                    <h2>Auszeichnungen</h2>
                    <HorizontalScroll style="scrollbar_light">
                        {awards != null && initAwards(awards)}
                        <img alt=""  src="/images/auszeichnungen/Wein_pur_Weinguide_2022-23.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Falstaff_Guide_2022-23.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Vinaria_Weinguide_2022-23.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Vinaria_Premium_Rotwein_2022.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/A_la_Carte_Grand_Cru_2022.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Viktor-Siegl_Die-besten-Weine-Oesterreichs_2022.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Wein_mit_Egle-Wirtshausfuehrer_2022.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Wein_pur_Weinguide_2021-22.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Vinaria_Jungweinatlas_2021.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Genuss_Magazin_ZweigeltXOesterreich_2021.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Viktor-Siegl_Die-besten-Weine-Oesterreichs_2021.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Falstaff_Rotwein_Guide_2021.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Wein_mit_Egle-Wirtshausfuehrer_2021.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                        <img alt=""  src="/images/auszeichnungen/Wein_pur_Weinguide_2020-21.webp" style={{maxWidth:"250px", cursor:"pointer"}} width="1800" height="1800"/>
                    </HorizontalScroll>
                </div>
            </section>
            <section className="background_light">
                <span  className="anchor" id="weinblog" ></span>
                <div className="horizontal">
                    <div className="col-6 left">
                        <h2>Weinblog</h2>
                        <p>Hier erwarten Sie Ausschnitte aus unserem<br/> Weintagebuch & Gastartikel.  </p>
                        <Link href="/news/weinblog"><p className="button secondary x2">Mehr erfahren</p></Link>
                    </div>
                    <div className="col-6">
                        <img alt=""  src="/images/weinblog.webp" style={{width:"100%"}} width="610" height="313"/>
                    </div>
                </div>
            </section>
            <div className="transition_div horizontal">
                    <p className="col-4 right" style={{fontSize:"250px", marginTop:"125px"}}>&rdquo;</p>
                    <p className="col-8 left phrase white">Einen Blog schreiben ist fotografieren mit einer Tastatur.<br/><span className="size-16 narrow-light white">- Familie Gisperg</span> </p>
            </div>
            <section className="background_light">
                <span  className="anchor" id="socialmedia" ></span>
                <div className="col-12">
                    <h2>Social Media</h2>
                    <Link href="https://instagram.com/johanngisperg_burgunderweingut" target="_blank"><p className="button primary x2 uppercase" style={{marginBottom:"100px"}}>Zu Instagram</p></Link>
                    {/*<InstagramFeed token="IGQVJVd1lnY3FZAOFh5NkpHZAnJjWjlHX2RYN3dHNGxqZAlRoY1VfanN5RDhwM1FaUFhrd3lBVWU5ODhIT1JOZAEZAZAR3pxUl9jMzRpb3RBZAENQSjNYRUhYZAHA0YVZAwUWpERXctUEhsZAkxRSHcwRk5rbk5sZAQZDZD" counter="12"/>*/}
                </div>
            </section>
        </Layout>
    )
}

function getAwards(){
    return fetch("https://api.gisperg.wine/api/Award/All",{
        method:'GET',
        mode: 'cors'
    }).then((res)=> res.json());
}